// @flow
import * as React from 'react';

import { useDispatch } from 'react-redux';

import {
  updateProductAndGetCartOrNotify,
  type DecoratedProduct,
} from '@gandi/cart';
import { useTranslator } from '@gandi/translate';

import type { GandiFormSelectOption } from 'src/Domain/types';

import ProductItem from './components/ProductItem';
import { DurationRow } from './components/Rows';

type Props = {
  product: DecoratedProduct,
};

const DNS_DURATION_ONE_MONTH = 1;
const DNS_DURATION_ONE_YEAR = 12;

const DNS_VALUES: Array<number> = [
  DNS_DURATION_ONE_MONTH,
  DNS_DURATION_ONE_YEAR,
];

function PremiumDNSCreate({ product }: Props): React.MixedElement {
  const { fqdn, unitPrice } = product;
  const { __ } = useTranslator();

  const dispatch = useDispatch();

  const currentPrices = product.prices?.[0];

  const handleDurationChange: (
    selectOption: GandiFormSelectOption<string>,
  ) => void = (selectedOption: GandiFormSelectOption<string>) => {
    const newPayload = {
      ...product.payload,
      duration: parseInt(selectedOption.value, 10),
    };

    dispatch(updateProductAndGetCartOrNotify(__, product.id, newPayload));
  };

  const currentDurationValue: number = currentPrices?.duration || 1;

  return (
    <ProductItem
      label={__('Pack DNS Security+')}
      detail={fqdn || ''}
      productId={product.id}
      footer={
        <DurationRow
          value={currentDurationValue}
          values={DNS_VALUES}
          unit="m"
          disabledOption={!!product.isWorking}
          // $FlowFixMe[incompatible-type-arg] - number is number|string
          onChange={handleDurationChange}
          productId={product.id}
          total={product.isWorking ? undefined : unitPrice}
        />
      }
    />
  );
}

export default PremiumDNSCreate;
